export { default as request } from '../../request';

export const serviceName = '/smart-site/jiangsu';
export const oldServiceName = '/smart-site';
